import React from "react";
import SignInForm from "../../../components/forms/SignInForm";
import Error from "../../../components/forms/Error";
import { connect } from "react-redux";

import "../Auth.scss";

const SignInPage = ({ error }) => {
  return (
    <div className="form-wrapper px-16 py-8">
      <SignInForm></SignInForm>
      <Error error={error}left></Error>
    </div>
  );
};

const mapStateToProps = (state) => {
  return { error: state.auth.error };
};

export default connect(mapStateToProps)(SignInPage);
